"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.realtimeService = void 0;
const socket_io_client_1 = require("socket.io-client");
const realtimeConfig_1 = require("../config/realtimeConfig");
class RealtimeService {
    constructor() {
        this.socket = null;
        this.currentUrl = '';
        this.currentChannelId = null;
        this.currentDmInfo = null;
    }
    init() {
        const serverUrl = (0, realtimeConfig_1.getRealtimeServerUrl)();
        if (this.socket && this.currentUrl === serverUrl) {
            if (!this.socket.connected) {
                this.socket.connect();
            }
            return this.socket;
        }
        if (this.socket) {
            this.socket.disconnect();
        }
        this.currentUrl = serverUrl;
        console.log(`[RealtimeService] Connecting to Socket.io server at ${serverUrl}`);
        this.socket = (0, socket_io_client_1.io)(serverUrl, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            timeout: 20000,
        });
        this.socket.on('connect', () => {
            console.log(`[RealtimeService] Connected successfully. Socket ID: ${this.socket?.id}`);
            // Re-join current active room if any
            if (this.currentChannelId) {
                this.joinChatChannel(this.currentChannelId);
            }
            else if (this.currentDmInfo) {
                this.joinChatDM(this.currentDmInfo.currentUserId, this.currentDmInfo.dmUserId);
            }
        });
        this.socket.on('disconnect', (reason) => {
            console.warn(`[RealtimeService] Disconnected from server: ${reason}`);
        });
        this.socket.on('connect_error', (error) => {
            console.warn(`[RealtimeService] Connection error:`, error.message);
        });
        return this.socket;
    }
    getSocket() {
        if (!this.socket) {
            return this.init();
        }
        return this.socket;
    }
    joinChatChannel(channelId) {
        const s = this.getSocket();
        if (this.currentChannelId && this.currentChannelId !== channelId) {
            this.leaveChatChannel(this.currentChannelId);
        }
        this.currentChannelId = channelId;
        this.currentDmInfo = null;
        s.emit('chat:join', { channelId });
    }
    leaveChatChannel(channelId) {
        const s = this.getSocket();
        s.emit('chat:leave', { channelId });
        if (this.currentChannelId === channelId) {
            this.currentChannelId = null;
        }
    }
    joinChatDM(currentUserId, dmUserId) {
        const s = this.getSocket();
        if (this.currentChannelId) {
            this.leaveChatChannel(this.currentChannelId);
        }
        this.currentDmInfo = { currentUserId, dmUserId };
        s.emit('chat:join', { currentUserId, dmUserId });
    }
    leaveChatDM(currentUserId, dmUserId) {
        const s = this.getSocket();
        s.emit('chat:leave', { currentUserId, dmUserId });
        this.currentDmInfo = null;
    }
    broadcastMessage(payload) {
        const s = this.getSocket();
        s.emit('chat:message', payload);
    }
    sendTyping(payload) {
        const s = this.getSocket();
        s.emit('chat:typing', payload);
    }
    sendReaction(payload) {
        const s = this.getSocket();
        s.emit('chat:reaction', payload);
    }
    sendEdit(payload) {
        const s = this.getSocket();
        s.emit('chat:edit', payload);
    }
    sendDelete(payload) {
        const s = this.getSocket();
        s.emit('chat:delete', payload);
    }
}
exports.realtimeService = new RealtimeService();
